/*
 * FeelMoreEnergy custom announcement bar
 * - Rotates messages with a cross-fade (respects data-autoplay + data-speed)
 * - Pause-on-hover (desktop): stops rotation while the pointer is over the bar
 * - Tap-to-advance (mobile/click): tapping the bar jumps to the next message
 * - Click-to-copy promo code (.fme-announcement-bar__code)
 * No dependencies, no framework. Loaded with defer.
 */
(function () {
  function initCopy(bar) {
    var codes = bar.querySelectorAll('.fme-announcement-bar__code');
    if (!codes.length) return;

    codes.forEach(function (code) {
      function copy() {
        var value = code.getAttribute('data-code') || '';
        if (value && navigator.clipboard) {
          navigator.clipboard.writeText(value).catch(function () {});
        }
        code.classList.add('is-copied');
        setTimeout(function () {
          code.classList.remove('is-copied');
        }, 1400);
      }

      code.addEventListener('click', function (event) {
        event.stopPropagation(); // don't also trigger tap-to-advance
        copy();
      });
      code.addEventListener('keydown', function (event) {
        if (event.key === 'Enter' || event.key === ' ') {
          event.preventDefault();
          copy();
        }
      });
    });
  }

  function initRotate(bar) {
    var messages = bar.querySelectorAll('.fme-announcement-bar__msg');
    if (messages.length < 2) return;

    var autoplay = bar.dataset.autoplay === 'true';
    var speed = (parseFloat(bar.dataset.speed) || 5) * 1000;
    var index = 0;
    var timer = null;

    function show(target) {
      messages[index].classList.remove('is-active');
      messages[index].setAttribute('aria-hidden', 'true');
      index = (target + messages.length) % messages.length;
      messages[index].classList.add('is-active');
      messages[index].removeAttribute('aria-hidden');
    }

    function start() {
      if (!autoplay || timer) return;
      timer = setInterval(function () {
        show(index + 1);
      }, speed);
    }

    function stop() {
      if (timer) {
        clearInterval(timer);
        timer = null;
      }
    }

    // Pause while the shopper is reading (desktop hover).
    bar.addEventListener('mouseenter', stop);
    bar.addEventListener('mouseleave', start);

    // Tap anywhere on the bar to advance (great on mobile). Ignore taps on the
    // copy button (handled separately) and on real links.
    bar.addEventListener('click', function (event) {
      if (event.target.closest('.fme-announcement-bar__code')) return;
      if (event.target.closest('a')) return;
      show(index + 1);
    });

    start();
  }

  function init() {
    var bars = document.querySelectorAll('.fme-announcement-bar');
    if (!bars.length) return;
    bars.forEach(function (bar) {
      initCopy(bar);
      initRotate(bar);
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
